export class AdvancedRosterSearch {
    Name: string;
    Status: number;
    ApproverUserId: string;
    Act48Status: number;
    GroupIDs: string[];
}